
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class DispositiviDialog extends Serenity.EntityDialog<DispositiviRow, any> {
        protected getFormKey() { return DispositiviForm.formKey; }
        protected getIdProperty() { return DispositiviRow.idProperty; }
        protected getLocalTextPrefix() { return DispositiviRow.localTextPrefix; }
        protected getNameProperty() { return DispositiviRow.nameProperty; }
        protected getService() { return DispositiviService.baseUrl; }
        protected getDeletePermission() { return DispositiviRow.deletePermission; }
        protected getInsertPermission() { return DispositiviRow.insertPermission; }
        protected getUpdatePermission() { return DispositiviRow.updatePermission; }

        protected form = new DispositiviForm(this.idPrefix);

    }
}